export const NO_TRACKING_ROUTES = new Set([
  "/allgemeine-geschaeftsbedingungen",
  "/datenschutzerklaerung",
]);

export function isNoTrackingRoute(pathname = "") {
  return NO_TRACKING_ROUTES.has(pathname);
}
